import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import { formatPrice } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import ChecklistItem from 'components/_new/ChecklistItem/ChecklistItem'

import PlanCard from 'components/upgradePlans/cards/components/PlanCard/PlanCard'
import CurrentPlanButton from 'components/upgradePlans/cards/components/CurrentPlanButton/CurrentPlanButton'

import messages from './messages'
import s from './UpgradePrepaidPlan.scss'


const UpgradePrepaidPlan = (props) => {
  const { className, data, isMobile, onButtonClick } = props
  const { discount, saveValue, productPrice, billingPeriod, totalPrice, selected } = data

  const handleClick = useCallback(() => {
    if (typeof onButtonClick === 'function') {
      onButtonClick(data)
    }
  }, [ onButtonClick, data ])

  return (
    <PlanCard {...{ className, discount, saveValue }}>
      <Box mt="36">
        <Text message={billingPeriod.toString()} semibold className={s.billingPeriod} />
        <Text message={messages.months} size="38-56" semibold />
      </Box>
      <Box mt="24" mb="72">
        <div role="list">
          <ChecklistItem iconColor="brand">
            <Text
              html
              message={{
                ...messages.save,
                values: {
                  saveValue,
                  discount: discount.substr(1),
                },
              }}
            />
          </ChecklistItem>
          <ChecklistItem iconColor="brand">
            <Text
              html
              message={{
                ...messages.plan,
                values: {
                  billingPeriod,
                  productPrice: formatPrice(productPrice, true, true),
                },
              }}
            />
          </ChecklistItem>
        </div>
      </Box>
      {
        selected ? (
          <CurrentPlanButton />
        ) : (
          <Button
            title={{
              ...messages.buttonTitle,
              values: {
                price: formatPrice(totalPrice, true, true),
              },
            }}
            size="md"
            color={isMobile ? 'brand' : 'brandBorder'}
            fullWidth
            onClick={handleClick}
          />
        )
      }
    </PlanCard>
  )
}

UpgradePrepaidPlan.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    name: PropTypes.string,
    discount: PropTypes.string,
    saveValue: PropTypes.string,
    productPrice: PropTypes.number.isRequired,
    totalPrice: PropTypes.number.isRequired,
    billingPeriod: PropTypes.number.isRequired,
  }),
  isMobile: PropTypes.bool,
  onButtonClick: PropTypes.func.isRequired,
}


export default UpgradePrepaidPlan
